import { FC } from 'react'
import { MaterialRequirementsConfiguration } from '../../../../../../../types/api/components/material/material-requirements-configuration'
import MaterialType from '../../../../../../../types/api/material-type'
import { useGetOrderRequestQuery } from '../../../../../../../store/api/order-requests-api'
import OrderRequest from './order-request'

interface OrderProps {
    config: MaterialRequirementsConfiguration
    materialType: MaterialType
    shipmentDocId: string
}

const Order: FC<OrderProps> = ({ config, materialType, shipmentDocId }) => {
    const getOrderRequestState = useGetOrderRequestQuery(
        {
            filters: {
                shipment: { documentId: { $eq: shipmentDocId } },
                material: { documentId: { $eq: config.material?.documentId } },
            },
        },
        { refetchOnMountOrArgChange: true }
    )
    const orderRequests = getOrderRequestState?.data?.data || []

    return (
        <OrderRequest
            config={config}
            materialType={materialType}
            shipmentDocId={shipmentDocId}
            data={orderRequests}
        />
    )
}

export default Order
